module.exports = __webpack_public_path__ + "static/google-partner-896879a0a7943cef8efca55aff1942fa.jpg";